import { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { H4, Body1, Loader, Paginator } from '../../cdl-react-components/components'
import ArticleItem from './ArticleItem'
import ActivityMapItem from './ActivityMapItem'
import RegionalMapItem from './RegionalMapItem'
import { onDesktop } from '../../cdl-react-components/utilities'
import { SearchParameter } from '../../../utilities/models'
import { updateSearchParameters } from '../../../store/actions/search'

class Results extends Component {
    changePage = (page) => {
        const parameters =
            this.props.parameters
                .filter(x => x.name !== 'page')
                .concat(new SearchParameter('page', page))

        this.props.updateSearchParameters(parameters)
    }

    handleResultSelect = () => {
        if(!onDesktop()) 
            this.props.onComplete()
    }

    render() {
        let results =
            (this.props.results &&
            this.props.results.content &&
            !this.props.searching) ?
                this.props.results.content.map(item => {
                    return (
                        <Fragment key={'results__item--' + item.id}>
                            { item.contentType === 'articles' ? <ArticleItem handleResultSelect={this.handleResultSelect} article={item} /> :
                              item.contentType === 'activityMaps' ? <ActivityMapItem handleResultSelect={this.handleResultSelect} activityMap={item} /> :
                              item.contentType === 'regionalMaps' ? <RegionalMapItem handleResultSelect={this.handleResultSelect} regionalMap={item} /> :
                              null }
                        </Fragment>
                    )
                }) :
                <Loader />
        
        if (this.props.results && 
            this.props.results.count === 0 &&
            !this.props.searching)
            results = <Body1>No Results Found</Body1>

        const count = 
            this.props.results &&
            this.props.results.count

        const page = (
            (this.props.parameters && 
            this.props.parameters.find(x => x.name === 'page')) ||
            { value: 1 }
        ).value

        return (
            <div className="results mdc-elevation--z6">
                <div className="results__content">
                    <H4>{ (this.props.parameters && this.props.parameters.length > 0) ? 'Results' : 'Content' }</H4>
                    {results}
                </div>
                <div className="results__footer">
                    <Paginator
                        page={page}
                        pageSize={10}
                        count={count || 0}
                        callback={this.changePage}/>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ search }) => ({
    parameters: search.parameters,
    results: search.results,
    searching: search.searching
})

const mapDispatchToProps = (dispatch) => ({
    updateSearchParameters: (paramters) => dispatch(updateSearchParameters(paramters))
})

export default connect(mapStateToProps, mapDispatchToProps)(Results)